import Cookie from 'js-cookie'


export const set_cookie = (key, value, expires_in = 7) => {
  Cookie.set(key, value, {expires: expires_in})
}
